// extracted by mini-css-extract-plugin
export default {"root":"LCI_7","list":"EZMBv","tab":"dxb8_","tabLabel":"GJRXU","tabSection":"U8_Yt","panel":"pcv_3"};